import { FormEvent, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import toast from "react-hot-toast"
import { lumi } from "@/lib/lumi"
import { SITE } from "@/data/site"
import { useAuth } from "@/hooks/useAuth"

function AdminLogin() {
  const { isReady, isAdmin } = useAuth()
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (isReady && isAdmin) {
      window.location.href = "/admin/orders"
    }
  }, [isReady, isAdmin])

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setSubmitting(true)
    try {
      await lumi.auth.signInWithPassword({ username, password })
      window.location.href = "/admin/orders"
    } catch (error) {
      console.error("登入失敗：", error)
      toast.error("登入失敗，請確認帳號與權限")
      setSubmitting(false)
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#080808] px-6 py-16">
      <div className="w-full max-w-md border border-white/10 bg-[#0c0c0c] px-8 py-12">
        <p className="font-sans-ui text-center text-[11px] tracking-[0.4em] text-[#c4a574]">ADMIN</p>
        <h1 className="font-display mt-4 text-center text-3xl text-[#f7f1e6]">訂單後台</h1>
        <p className="font-serif-tc mt-3 text-center text-sm text-stone-500">{SITE.brandDisplay} · {SITE.artist}</p>
        <form className="mt-10 flex flex-col gap-8" onSubmit={handleSubmit}>
          <label className="flex flex-col gap-3">
            <span className="font-sans-ui text-sm tracking-[0.22em] text-stone-300">帳號</span>
            <input
              required
              type="text"
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              className="border-b border-white/15 bg-transparent pb-2 font-serif-tc text-base text-stone-100 outline-none focus:border-[#c4a574]"
            />
          </label>
          <label className="flex flex-col gap-3">
            <span className="font-sans-ui text-sm tracking-[0.22em] text-stone-300">密碼</span>
            <input
              required
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="border-b border-white/15 bg-transparent pb-2 font-serif-tc text-base text-stone-100 outline-none focus:border-[#c4a574]"
            />
          </label>
          <button
            type="submit"
            disabled={submitting}
            className="font-sans-ui mt-2 border border-[#c4a574]/60 px-8 py-3 text-sm tracking-[0.32em] text-[#c4a574] transition-colors duration-500 hover:bg-[#c4a574] hover:text-[#080808] disabled:cursor-not-allowed disabled:opacity-40"
          >
            {submitting ? "登入中" : "登入"}
          </button>
        </form>
        <p className="mt-8 text-center">
          <Link to="/" className="font-sans-ui text-[11px] tracking-[0.18em] text-stone-600 hover:text-[#c4a574]">
            返回網站
          </Link>
        </p>
      </div>
    </main>
  )
}

export default AdminLogin
